import { CollectionType, CommentType, ProductType, RecommendationType, UserType } from '@/@types';
import React, { useContext } from 'react';

type ContextValuesType = {
  product?: ProductType;
  user?: UserType;
  comment?: CommentType;
  recommendation?: RecommendationType;
  collection?: CollectionType;
};

export const FeedContext = React.createContext<
  ContextValuesType & {
    priority?: boolean;
    playing?: boolean;
  }
>({ playing: false });

export const useFeed = (props?: ContextValuesType) => {
  const contextValues = useContext(FeedContext);
  return {
    ...contextValues,
    ...props,
  };
};

export const FeedGroupContext = React.createContext<{
  /**
   * Product or Recommendation Id of the current playing video
   */
  playing: string | null;
}>({
  playing: null,
});

export const useFeedGroup = () => {
  return useContext(FeedGroupContext);
};
